module.exports = __webpack_public_path__ + "img/mayday-rounded.45492aed.svg";